export default __webpack_public_path__ + "static/gs-3-publishmodel-1872837c14d25583eb22727c62d0f4be.webp";